<template>
    <!-- 实名认证页面 -->
  <div class="main">
    <h1>根据中国证监会的要求，接受证券类服务必须进行实名认证，请您准确填写。</h1>
    <h2>
        <span>姓名</span>
        <span class="tip">{{ name_tip }}</span>
    </h2>

    <div class="input_box" @click="foucusFn('input_1')">
        <div class="svg_box">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9 4.7517C9.9 2.54874 8.154 0.763062 6 0.763062C3.846 0.763062 2.1 2.54874 2.1 4.7517C2.099 6.04844 2.71525 7.26453 3.7518 8.01133C1.6131 8.97812 0 11.2283 0 13.6494C0 13.9883 0.268629 14.2631 0.6 14.2631C0.931371 14.2631 1.2 13.9883 1.2 13.6494C1.2 11.1077 3.5148 8.74033 6 8.74033C8.4852 8.74033 10.8 11.1077 10.8 13.6494C10.8 13.9883 11.0686 14.2631 11.4 14.2631C11.7314 14.2631 12 13.9883 12 13.6494C12 11.2286 10.3872 8.97812 8.2482 8.01133C9.2475 7.28908 9.9 6.09863 9.9 4.7517ZM3.3 4.7517C3.3 3.22665 4.50883 1.99034 6 1.99034C7.49117 1.99034 8.7 3.22665 8.7 4.7517C8.7 6.27676 7.49117 7.51307 6 7.51307C4.50883 7.51307 3.3 6.27676 3.3 4.7517Z" fill="#B5B5B5"/>
            </svg>
        </div>
        <input type="text" placeholder="真实姓名" v-model="name" id="input_1">
    </div>
    
    
    <h2>
        <span>身份证号</span> 
        <span class="tip">{{ number_tip }}</span>
    </h2>

    <div class="input_box" @click="foucusFn('input_2')">
        <div class="svg_box svg_box2">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.88893 0.263062H15.1113C16.154 0.264185 16.999 1.09013 17 2.10926V10.4171C16.9991 11.4362 16.154 12.2621 15.1113 12.2631H1.88893C0.84621 12.262 0.00114911 11.4362 0 10.4171V2.10926C0.00114892 1.0901 0.846179 0.264184 1.88893 0.263062ZM15.1111 11.3402C15.6324 11.3395 16.0548 10.9266 16.0554 10.417V2.10925C16.0548 1.59982 15.6325 1.18696 15.1113 1.18625H1.88894C1.3676 1.18696 0.945191 1.5999 0.944565 2.10944V10.417C0.945295 10.9265 1.36765 11.3394 1.88894 11.3402H15.1111Z" fill="#B5B5B5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3265 6.62871C13.8367 6.20509 14.1672 5.58197 14.1672 4.87865C14.1672 3.6042 13.1101 2.57104 11.8062 2.57104C10.5022 2.57104 9.44514 3.6042 9.44514 4.87865C9.44514 5.58253 9.77547 6.20509 10.2857 6.62871C9.22644 7.16792 8.50058 8.24893 8.50058 9.49405C8.50058 9.74898 8.71203 9.95565 8.97286 9.95565C9.23369 9.95565 9.44514 9.74898 9.44514 9.49405C9.43754 8.66466 9.88589 7.89508 10.6195 7.47822C11.3532 7.06137 12.2593 7.06137 12.993 7.47822C13.7266 7.89508 14.175 8.66466 14.1674 9.49405C14.1674 9.74898 14.3788 9.95565 14.6397 9.95565C14.9005 9.95565 15.1119 9.74898 15.1119 9.49405C15.1119 8.24893 14.3859 7.16792 13.327 6.62871H13.3265ZM10.3889 4.87865C10.3889 4.31862 10.7341 3.81373 11.2635 3.59943C11.7929 3.38513 12.4022 3.50363 12.8074 3.89966C13.2125 4.29569 13.3337 4.89126 13.1144 5.40864C12.895 5.92603 12.3784 6.26333 11.8054 6.26325C11.4297 6.26325 11.0694 6.11737 10.8038 5.8577C10.5381 5.59803 10.3889 5.24585 10.3889 4.87865ZM2.36114 3.49387H8.02774C8.28857 3.49387 8.50002 3.70053 8.50002 3.95546C8.50002 4.21039 8.28857 4.41706 8.02774 4.41706H2.36114C2.1003 4.41706 1.88885 4.21039 1.88885 3.95546C1.88885 3.70053 2.1003 3.49387 2.36114 3.49387ZM7.55546 5.80166H2.36113C2.19018 5.79831 2.03073 5.88554 1.94425 6.0297C1.85777 6.17387 1.85777 6.35246 1.94425 6.49662C2.03073 6.64079 2.19018 6.72801 2.36113 6.72467H7.55546C7.72641 6.72801 7.88586 6.64079 7.97234 6.49662C8.05882 6.35246 8.05882 6.17387 7.97234 6.0297C7.88586 5.88554 7.72641 5.79831 7.55546 5.80166ZM2.36114 8.10963H6.13881C6.39964 8.10963 6.61109 8.3163 6.61109 8.57123C6.61109 8.82616 6.39964 9.03283 6.13881 9.03283H2.36114C2.1003 9.03283 1.88885 8.82616 1.88885 8.57123C1.88885 8.3163 2.1003 8.10963 2.36114 8.10963Z" fill="#B5B5B5"/>
            </svg>
        </div>
        <input id="input_2" type="text" placeholder="请输入身份证号仅（仅用于合同，不外泄）"  v-model="number">
    </div>

    
    <h1>以上信息的真实性由您保证</h1>


    <h2 class="title2"><span>下列包括：</span> （点击图片可查看大图）</h2>

    <h2 v-for="item in pictures_intro">{{item}}</h2>

    <div class="img_box">
        <img :src="item" alt="" v-for="item in img" @load="$previewRefresh" 
            :preview="1">
    </div>

    <h1>如有疑问，请点击<span @click="goPage">爱股票小秘书</span>咨询</h1>


    <div class="btn" @click="finish">点击此处签署协议</div>

  </div>
</template>

<script>
import "@/utils/flexible";
import goldApi from '@/api/gold/detail.js'

import {appversion,user_id,CURRENT_ENV_PRE } from "@/utils/urlQuery";

export default {
    data() {
        return {
            name:'',//姓名
            number:'',//身份证号
            name_tip:'',//姓名校验提示
            number_tip:'',//身份证号校验提示
            img:[],//协议图片数据
            pictures_intro:[],//协议图片数据 名称
            l_id:this.$route.query.l_id, //购买老师id
            agreement_id:this.$route.query.agreement_id,//合同id
            order:this.$route.query.order, //支付的订单号

        };
    },
    created() {
        //获取协议图片
        this.getdata();  
        setTimeout(() => {
            this.real_info();
        }, 10); 
    },
    mounted() {
        
    },
    methods:{
        foucusFn(id){
            this.$nextTick(() => {
                document.getElementById(id).focus();
            })
        },
        async getdata() {
            //获取协议图片
            let res = await goldApi.user_sign_see();
            if(res.rslt == "succ") {
                this.pictures_intro = res.pictures_intro;
                this.img = res.pictures;
            }
        },
        goPage(){
            //跳转客服 小秘书
            //this.$downapppop.open('查看');
            location.href = `/up/mes/108388`;
        },
        async real_info(){
            let res = await goldApi.real_info();
            console.log('res',res);
            if(res.status == "success" && res.data && res.data.id) {
                this.name = res.data.truename;
                this.number = res.data.idcard;
            }
        },
        async finish(){
            //实名认证接口
            //中文姓名校验 英文姓名校验 身份证号校验
            let name_p = /^[\u00B7\u3007\u3400-\u4DBF\u4E00-\u9FFF\uE000-\uF8FF\uD840-\uD8C0\uDC00-\uDFFF\uF900-\uFAFF]+$/,
                name_p_en = /^[A-Z][a-z]*(\s[A-Z][a-z]*)*$/,
                number_p =  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

            if(!this.name.match(name_p) && !this.name.match(name_p_en)){
                this.name_tip = '*请输入正确格式';
                return false;
            }
            else{
                this.name_tip = '';
            }
            if(!this.number.match(number_p)){
                this.number_tip = '*请输入正确格式';
                return false;
            }
            else{
                this.number_tip = '';
            }
            //接口需要登录token
            let res = await goldApi.idCard({
                real_name:this.name,
                id_card_no:this.number,
            });
            if(res.code == 1) {
                //跳转签名页面
                location.href = `/up/app/signAgreement?l_id=${this.l_id}&order=${this.order}&name=${this.name}&number=${this.number}&agreement_id=${this.agreement_id}`;
            }
            else{
                this.number_tip = res.message || '*用户姓名与身份证号信息不符';
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.main{
    height: 100vh;
    background: #fff;
    >h1{
        color: #939393;
        font-size: 14px;
        line-height: 18px; /* 128.571% */
        margin: 0 12px 15px;
        padding-top: 10px;
        >span{
            color:#1D88D0;
        }
    }
    >h2{
        margin: 10px 12px;
        color:#333;
        font-size: 14px;
        &.title2{
            color: #939393;
            font-weight: bold;
            border-top: 1px solid #ebebeb;
            margin: 10px 0;
            padding: 19px 12px 0;
        }

        >span{
            font-size: 14px;
            font-weight: bold;
            line-height: 17px;
            color:#333;
            &.tip{
                font-size: 13px;
                font-weight: normal;
                line-height: 17px;
                color: #FF3030;
                margin-left: 10px;
            }
        }
        
    }

    input{
        width: calc(100% - 24px);
        box-sizing: border-box;
        display: flex;
        margin: 10px 12px;
        line-height: 18px;
        flex-shrink: 0;
        border-radius: 3px;
        border: 1px solid #DCDCDC;
        background: #FAFAFA;
        padding: 9.5px  5px 9.5px 42.5px ;
        color:#333;
        font-size: 14px;
    }

    .input_box{
        position: relative;
        .svg_box{
            height: 17px;
            position: absolute;
            left: 24px;
            top: 11px;
            border-right: 1px solid #ebebeb;
            display: flex;
            align-items: center;
            padding-right: 11px;
            >svg{
                width: 12px;
                height: 13.5px;
                flex-shrink: 0;
            }
            &.svg_box2{
                left: 22px;
                padding-right: 8px;
                >svg{
                    width: 17px;
                    height: 12px;
                    flex-shrink: 0;
                }
                
            }
        }
    }

    .img_box{
        display: flex;
        margin: 10px  12px;
        flex-wrap: wrap;
        justify-content: space-between;
        >img{
            width: 100px;
            height: 140px;
            flex-shrink: 0;
            border: 1px solid #ebebeb;
            //margin-right: 20px;
        }
    }

    .btn{
        width: 100%;
        height: 50px;
        flex-shrink: 0;
        position: fixed;
        bottom: 0;
        left: 0;
        background: #FE484A;
        display: flex;
        align-items: center;
        justify-content: center;
        color:#fff;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>